"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Loops over each item of a sequence.
 *
 * <pre>
 * <ul>
 *  {% for user in users %}
 *    <li>{{ user.username|e }}</li>
 *  {% endfor %}
 * </ul>
 * </pre>
 */
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const syntax_1 = require("../error/syntax");
class TwingTokenParserExtends extends token_parser_1.TwingTokenParser {
    parse(token) {
        let stream = this.parser.getStream();
        if (!this.parser.isMainScope()) {
            throw new syntax_1.TwingErrorSyntax('Cannot extend from a block.', token.getLine(), stream.getSourceContext());
        }
        if (this.parser.getParent() !== null) {
            throw new syntax_1.TwingErrorSyntax('Multiple extends tags are forbidden.', token.getLine(), stream.getSourceContext());
        }
        this.parser.setParent(this.parser.getExpressionParser().parseExpression());
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return null;
    }
    getTag() {
        return 'extends';
    }
}
exports.TwingTokenParserExtends = TwingTokenParserExtends;
